import * as React from 'react';
import './ContentFrameComponent.css';

interface IContentFrameComponentProps {
    children?: any
}

class ContentFrameComponent extends React.PureComponent<IContentFrameComponentProps> {
    public render() {
        return (
            <div className='w_main_container'>
                {this.props.children}
            </div>
        );
    }
}

export default ContentFrameComponent;


// WEBPACK FOOTER //
// ./src/components/ContentFrameComponent/ContentFrameComponent.tsx